export default "/fonts/vendor/react-notifications/lib/notification.woff?c392cd33d9d9de730f9d5c95e42b7c84";